import { Injectable } from "@angular/core";
import {
  NgbDateStruct,
  NgbCalendar,
  NgbDate,
} from "@ng-bootstrap/ng-bootstrap";

@Injectable({
  providedIn: "root",
})
export class StrategyDataParserService {
  constructor(private calendar: NgbCalendar) {}

  parseFetchedDataValues(fetchedData, date, keyModifier) {
    // fertDate : {...}
    for (const [factor, factorObject] of Object.entries(fetchedData)) {
      // dwn2005: "0.01"
      for (const [key, value] of Object.entries(factorObject)) {
        // Factor value
        // eg: fac2006: "990.92" || fac2006_1: ...
        if (key === `fac${date.year}${keyModifier}`) {
          date[factor] = this.parseInputValue(factor, value);
        }
        //Upper uncertainity range if present
        if (key === `up${date.year}${keyModifier}`) {
          date[`${factor}up`] = this.parseInputUncertainityValue(
            factor,
            date[factor],
            value,
            true
          );
        }
        //Lower uncertainity range if present
        if (key === `dwn${date.year}${keyModifier}`) {
          date[`${factor}dwn`] = this.parseInputUncertainityValue(
            factor,
            date[factor],
            value,
            false
          );
        }
      }
    }
  }

  /**
   * Calculates uncertainity value for factor
   * @param mod: boolean - determines whether the upper or lower uncertainity (+/-) is being calculated
   */
  parseInputUncertainityValue(factor, facvalue, value, mod) {
    if (facvalue == "nan" || value == "nan") return null;
    var modifier = mod ? 1 : -1; // + or -

    if (factor == "fertdate") {
      let val = modifier * Math.round(parseFloat(<string>value)); //round floats to full day
      let factorDate = new Date(facvalue); //Create JS date from ISO string
      let date = factorDate.setDate(factorDate.getDate() + val); //Add uncertainty to date
      return new Date(date).toISOString();
    } else {
      const val = modifier * parseFloat(<string>value);
      return parseFloat(facvalue) + val;
    }
  }

  /**
   * Parses value of factor into correct form
   */
  parseInputValue(factor, value) {
    if (value === "nan") return null;
    if (factor === "fertdate") {
      return this.getUtcYearMonthDate(value);
    } else {
      return ["ffdate", "lfdate"].includes(factor)
        ? this.getDayInYear(value)
        : parseFloat(<string>value);
    }
  }

  /**
   * Parses input dateString into yyyy-mm-dd format
   */
  getUtcYearMonthDate(dateString) {
    if (dateString === "nan") return null;
    const dA = dateString.split("-");
    const date = new Date(dA[0], dA[1], dA[2]);
    return date.toISOString();
  }

  /**
   * Conversts date(Year-Month-Day into  day in year number
   */
  getDayInYear(dateString) {
    if (dateString === "nan") return "0";
    const dA = dateString.split("-");
    const date = new Date(dA[0], dA[1], dA[2]);
    return (
      (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
        Date.UTC(date.getFullYear(), 0, 0)) /
      24 /
      60 /
      60 /
      1000
    );
  }

  /**
   * Conversts week number into 'Monday' representation of Year-Month-Day format
   * @param w Week number
   * @param y Year
   */
  getDateOfWeek(weekNo, yearNo) {
    let firstDayofYear = new Date(yearNo, 0, 1);

    if (firstDayofYear.getDay() > 4) {
      let date = new Date(
        yearNo,
        0,
        1 + (weekNo - 1) * 7 - firstDayofYear.getDay() + 8
      );
      return `${date.getUTCFullYear()}-${
        date.getUTCMonth() + 1
      }-${date.getUTCDate()}`;
    } else {
      let date = new Date(
        yearNo,
        0,
        1 + (weekNo - 1) * 7 - firstDayofYear.getDay() + 1
      );
      return `${date.getUTCFullYear()}-${
        date.getUTCMonth() + 1
      }-${date.getUTCDate()}`;
    }
  }

  getWeek(prev, after, selectedDate): NgbDate[] {
    let week = [selectedDate];
    if (prev > 0) {
      this.getPreviousDay(selectedDate, prev, week);
    }
    if (after > 0) {
      this.getNextDay(selectedDate, after, week);
    }
    return week;
  }

  getPreviousDay(day, prev, week) {
    const nextday = this.calendar.getPrev(day);
    week.unshift(nextday);
    if (prev - 1 != 0) {
      this.getPreviousDay(nextday, prev - 1, week);
    }
  }

  getNextDay(day, after, week) {
    const nextday = this.calendar.getNext(day);
    week.push(nextday);
    if (after - 1 != 0) {
      this.getNextDay(nextday, after - 1, week);
    }
  }

  getWeekNumber(date: NgbDateStruct): number {
    const selectedDate = new NgbDate(date.year, date.month, date.day);
    const selectedWeekday = this.calendar.getWeekday(selectedDate);
    return this.calendar.getWeekNumber(
      this.getWeek(selectedWeekday - 1, 7 - selectedWeekday, selectedDate),
      1
    );
  }

  /**
   * Adjusted week number = week number of selected day - 4 weeks
   */
  getSeasonStartWeekNumber(date: NgbDateStruct): number {
    const selectedDate = new NgbDate(date.year, date.month, date.day);
    const adjustedDate = this.calendar.getPrev(selectedDate, "d", 21);
    return this.getWeekNumber(adjustedDate);
  }
}
